import Vue from 'vue'
import InputMask from 'vue-input-mask'
Vue.component('InputMask', InputMask)
